export const validation = {
  description: 'Description is required',
  infoUrl: 'Information url is required',
  finBankName: 'Bank name is required',
  finBankUrl: 'Bank url is required',
};
